import { BaseService, GameBaseApi, GameStatisticBase, GameTeamStatisticBase, GameUser } from '@mtgame/core';
import { Observable } from 'rxjs';
import { GameRootService } from '@core/services/game-root.service';
import { Injectable } from '@angular/core';

export const STORE_TEAM_STATISTIC_KEY = 'teamStatistic';
export const STORE_USER_STATISTIC_KEY = 'userStatistic';
export const STORE_MVP_USERS_KEY = 'mvpUsers';

@Injectable()
export abstract class GameStatisticService extends BaseService {
  protected gameId: number;

  abstract teamStatistic$: Observable<GameTeamStatisticBase>;
  abstract userStatistic$: Observable<GameStatisticBase[]>;

  get mvpUsers$(): Observable<GameUser[]> {
    return this.store.get(STORE_MVP_USERS_KEY);
  }

  constructor(
    protected gameRootService: GameRootService,
    protected gameBaseApi: GameBaseApi,
  ) {
    super();
  }

  async initialize(): Promise<void> {
    const game = this.gameRootService.getGameModel();
    this.gameId = game.id;
    await Promise.all([
      this.getTeamStatistic(),
      this.getUserStatistic(),
      this.getMvpUsers(),
    ]);
  }

  async getMvpUsers(): Promise<GameUser[]> {
    const mvpUsers = await this.gameBaseApi.getMvp(this.gameId);
    this.store.save(STORE_MVP_USERS_KEY, mvpUsers);
    return mvpUsers;
  }

  abstract getTeamStatistic(): Promise<GameTeamStatisticBase>;
  abstract getUserStatistic(): Promise<GameStatisticBase[]>;
}
